export const KNOWLEDGE_BASE_ENTRY_TYPES = [
  "plain_text",
  "json",
  "zendesk",
  "shelf",
  "file",
  "web_url",
  "api",
] as const

export type KnowledgeBaseEntryType = (typeof KNOWLEDGE_BASE_ENTRY_TYPES)[number]
